import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'replaceLineBreaks'})
export class ReplaceLineBreaks implements PipeTransform {

  transform(value: string) {
    if (value) {
      return value.replace(/\n/g, '<br/>');
    }
  }
}
